import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SettingsState } from './types';
import { getSettingsApiClient } from '../../../common/apiClients';
import { RootState } from '../../../app/store';
import { Settings, SettingsUpdatePayloadRequest, SettingsUpdateRequest } from '../../../generated/api';

const sliceName = 'settings';

export const fetchSettingsAsync = createAsyncThunk<Settings>(
  `${sliceName}/fetchSettings`,
  async (arg, { rejectWithValue }) => {
    try {
      const apiClient = await getSettingsApiClient();
      const result = await apiClient.settingsRetrieve({ id: 1 });
      return result;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const updateSettingsAsync = createAsyncThunk<Settings, SettingsUpdatePayloadRequest>(
  `${sliceName}/updateDefaultReportTexts`,
  async (arg, { rejectWithValue }) => {
    try {
      const apiClient = await getSettingsApiClient();
      const request: SettingsUpdateRequest = { id: 1, settingsUpdatePayloadRequest: arg };
      const result = apiClient.settingsUpdate(request);
      return result;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

const initialState: SettingsState = {
  loading: false,
  settings: null
};

const settingsSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchSettingsAsync.fulfilled.type]: (state: SettingsState, action: PayloadAction<Settings>): SettingsState => {
      return { ...state, settings: action.payload, loading: false };
    },
    [fetchSettingsAsync.pending.type]: (state: SettingsState): SettingsState => {
      return { ...state, loading: true };
    },
    [fetchSettingsAsync.rejected.type]: (state: SettingsState): SettingsState => {
      return { ...state, settings: null, loading: false };
    }
  }
});

export const selectSettings = (state: RootState): SettingsState => state.settings;
export default settingsSlice.reducer;
